<i18n lang="yaml">
  zh:
    title: "创作工具"
    subtitle: "限时免费-探索更多创作辅助工具"
    latest_news: "最新动态"
    contribute_title1: "收稿合作"
    contribute_title: "火葬场真香杯"
    contribute_content1: "自主收稿平台，创建你的征稿函！"
    contribute_content: "短篇挑战赛进行中🔥"
    empty_desc: "还没有创作记录，快开启加速之旅吧！"
    empty_tip: "Start your journey!"
    all: "全部"
    signed: "已签约"
    delete_confirm: "确定删除吗?"
    confirm: "确定"
    cancel: "取消"
    delete_signed_tip: "已签约作品不能删除"
    delete_submitted_tip: "投稿作品不能删除，请先撤回投稿"
    delete: "删除"
    no_story_name: "该故事还没有名字"
    recent_edit: "最近编辑"
    completed: "完成状态"
    search_placeholder: "输入名称搜索"
    select_story_type: "请选择故事类型"
    select_perspective: "请选择写作视角"
    menu_command_missing: "菜单选项缺少command属性"
  en:
    title: "Authoring Tool"
    subtitle: "Free for a Limited Time"
    latest_news: "Latest News"
    contribute_title: "Submission Cooperation"
    contribute_content: "Self-service submission platform, create your own call for papers!"
    empty_desc: "No creation records yet, start your journey now!"
    empty_tip: "Start your journey!"
    all: "All"
    signed: "Signed"
    delete_confirm: "Are you sure to delete?"
    confirm: "Confirm"
    cancel: "Cancel"
    delete_signed_tip: "Signed works cannot be deleted"
    delete_submitted_tip: "Submitted works cannot be deleted, please withdraw the submission first"
    delete: "Delete"
    no_story_name: "This story has no name yet"
    recent_edit: "Recently Edited"
    completed: "Completion Status"
    search_placeholder: "Enter name to search"
    select_story_type: "Please select story type"
    select_perspective: "Please select writing perspective"
    menu_command_missing: "Menu option missing command property"
</i18n>


<template>
<div>
    <div class="authoring-tool">
      <!-- authoringtool title-->
      <div style="position: relative;transform: translate(0);">
        <div style="font-weight: 600;font-size: 20px;color: rgba(0,0,0,0.8);" class="">
            <div style="align-items: center;display: flex;">
              {{ $t('title') }}
            </div>
            <div style="font-size: 12px;color: rgba(0,0,0,0.4);padding-bottom: 1rem;padding-top: .5rem;font-weight: 400;">
              {{ $t('subtitle') }}
            </div>
        </div>
      </div>

      <!-- authoringtool search -->
      <div class="d-flex flex-between flex-y-center" style="border-radius: 20px 0px 0px 0px;width: 100%;;margin-bottom: 1rem;">
        <div class="d-flex flex-between flex-y-center" style="width:100%;">
          <!-- left -->
          <div class="d-flex" v-if="enums.AgentToolTypeEnum">
            <div class="ly-story-gen-type pointer" :style="{'background': genTypeActive==item.name?'#366EF4':'rgba(172,178,255,0.2)','color': genTypeActive==item.name?'#FFFFFF':'rgba(54,110,244,0.5)', 'font-weight': genTypeActive==item.name?'600':''}"
             style="padding: .45rem 1.5rem;margin-right: 1rem;text-wrap: nowrap;
              border-radius: 20px;font-size: .8rem;"
                  v-for="(item,index) in sortByCode(enums.AgentToolTypeEnum)"
                  @click.stop="handlePage(item)"
                  :key="index" >
                      {{item.desc}}
            </div>
          </div>
        </div>
      </div>

      <div class="authoring-tool-box" style="">
        <div
          @click="goToolPage(item)"
          class="authoring-tool-box-item"
          v-for="(item,index) in data"
          :key="index" >
            <div class="authoring-tool-box-item-icon">
              <img v-if="item.icon.indexOf('renwusheding')>0" src="@/assets/renwusheding.png" style="width: 36px;"/>
              <img v-if="item.icon.indexOf('duanpiandaoyu')>0" src="@/assets/duanpiandaoyu.png" style="width: 36px;"/>
              <img v-if="item.icon.indexOf('redianxuanti')>0" src="@/assets/redianxuanti.png" style="width: 36px;"/>
            </div>
            <div class="authoring-tool-box-item-title">
              {{item.title}}
            </div>
            <div class="authoring-tool-box-item-subtitle">
              {{item.desc}}
            </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import * as StoryTemplateApi from '@/api/storytemplate'
import * as EnumApi from '@/api/enums'
import * as AuthApi from '@/api/auth'
import * as ArticleApi from '@/api/article'
import * as EvaluationApi from '@/api/evaluation'
import * as CultureApi from '@/api/culture'
import * as StoryCpApi from '@/api/storycp'
import * as StorySynesthesiaElementApi from '@/api/storysynesthesiaelement'
import * as StoryHotApi from '@/api/storyhot'
import { mapState, mapMutations} from 'vuex'
import StoryIdeaDialog from '@/components/StoryIdeaDialog/index'
import Gen4Outline from '@/components/Gen4Outline'
import HomeBox from '@/components/homebox/box-create'
export default {
  name: 'BoxTool',
  components: {
    StoryIdeaDialog,Gen4Outline,HomeBox
  },
  data() {
    return {
      genTypeActive: 'ALL',
      fromType: 'writer_client',
      dialogShowGenbyoutline: false,
      showStateFlag: true,
      dialogShowGenbyidea: false,
      // enums: {"ArticleTypeEnum":[{"desc":"","name":""}]},
    	targetPermit: 'article',
      queryForm: {
        name: '',
        fromType: 'writer-web',
        articleGenType: '-1',
        articleGenTypes: [],
        articleState: '',
        current: '',
        size: 20
      },
      activeMenuItem: 1,
      synesthesiaElements:[],
      cps:[],
      hots:[],
      storyTemplates:[],
      dongtai: [],
      tougao: [],
      data: [],
      data1: [
        {
          icon: '@/assets/renwusheding.png',
          type: 'PLAY',
          title: '人物设定',
          url: '{aip_url}/kq-bot.html?bot_id=7551341023532728354&app_id=11351970973&user_id={user_id}',
          desc: '完整人物设定档案，帮助剧本创作',
          botId: '7551341023532728354'

        },
        {
          icon: '@/assets/duanpiandaoyu.png',
          type: 'STORY',
          title: '短篇导语',
          desc: '一键生成爆款短篇导语',
          botId: '7545423159148232756'
        },
        {
          icon: '@/assets/redianxuanti.png',
          type: '',
          title: '热点选题',
          desc: '不知道写什么？最热选题',
          botId: '7548382537673605174'
        },
      ],
      queryForm: {
        name: '',
        fromType: 'writer-web',
        articleGenType: '-1',
        articleGenTypes: [],
        articleState: '',
        current: '',
        size: 20
      },
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  mounted() {
    this.handlePage()
  },
  computed: {
  	...mapState(['user', 'story', 'showDialogCdpFlag','enums','cozeBot','token',
    'showDialogDpFlag', 'showGenbyoutlineFlag', 'storyTiaojian'])
  },
  methods: {
    ...mapMutations(['setStory', 'setCozeBot','setShowLoginDialogFlag']),
    goToolPage(item){
      if(this.token==''){
        this.setShowLoginDialogFlag(true)
        return false;
      }
      this.setCozeBot(item)
      // console.log('cozeBot', this.cozeBot, item);
      AuthApi.saveTempToken()
      .then(res => {
      	// pagePath = '/pages/h5/index?pageIndex=kq-bot&url=' + encodeURIComponent(item.url+this.user.id+'&t='+Number(new Date()))
        this.$router.push('/account/tools')
        // AuthApi.getTempToken({accountId: this.user.id, appId: 1245});
      })
    },
    ...mapMutations(['setActiveMenuItem','setStory','setStoryContents','setEnums',
    'setShowGenbyoutlineFlag', 'setShowDialogCdpFlag', 'setShowDialogDpFlag',
     'setShowChangpianDialogFlag', 'setActiveTemplate', 'setStoryTiaojian', 'setShowZhilingPanelFlag']),
    contentChange(item){
      console.log('contentChange', item);
    },
    getTailByGenType(item){
      let tail = ''
      if(item.articleGenType == 'GEN_BY_ZHIHU' || item.articleGenType == 'GEN_BY_OUTLINE'){
        tail = this.$i18n.locale === 'zh' ? '短篇小说' : 'Short Story'
      }else if(item.articleGenType == 'GEN_BY_IDEA'){
        tail = this.$i18n.locale === 'zh' ? '超短篇小说' : 'Mini Story'
      }else if(item.articleGenType == 'GEN_BY_CHANGPIAN'){
        tail = this.$i18n.locale === 'zh' ? '长篇小说' : 'Novel'
      }else{
        tail = ''
      }
      return tail;
    },
    handleTemplateClick(item) {
      // console.log(item);
      this.setActiveTemplate(item)
      let story = {id: ''}
      story.articleGenType = 'GEN_BY_ZHIHU'
      story.articleType = 'FEEL_GOOD'
      this.setStory(story)
      setTimeout(()=>{
        this.$router.push('/workspace/gen')
      }, 300)
    },
    handleTemplatePage(){
      StoryTemplateApi.page({
        templateType: 'GUANFANG',
        enableFlag: true,
        size: 6
      }).then(res => {
        let result = res.data.data;
        this.storyTemplates = result.records;
      });
    },
    handleGen(cmditem) {
      if (!cmditem) {
        this.$message.error(this.$t('menu_command_missing'))
        return
      }
      let story = {id: ''}
      switch (cmditem) {
        case 'genbyidea'://cdp
          // gen story
          story.articleGenType = 'GEN_BY_IDEA'
          story.articleType = 'TANBI_DOUBLE_BOY'
          this.setStory(story)
          this.setShowDialogCdpFlag(true)
          break
        case 'genbyoutline'://duanpian dingzhi
          // gen story
          story.articleGenType = 'GEN_BY_OUTLINE'
          story.articleType = 'FEEL_GOOD'
          story.articleStyle = 'ZHENGWEN'
          story.writingPerspective = 'FIRST_PERSON'
          this.setStory(story)
          this.setShowGenbyoutlineFlag(true)
          break
        case 'genbyzhihu'://dp
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen'})
          break
        case 'genbychangpian'://changpian
          story.articleGenType = 'GEN_BY_CHANGPIAN'
          story.articleType = 'CP_YANQING'
          this.setStory(story)
          this.setShowChangpianDialogFlag(true)
          this.$router.push({ path: '/workspace/gencp'})
          break
        case 'chaishu':// chaishu
          this.$router.push({ path: '/bookbreakdown/index'})
          break
      }
    },
    newStoryByOutline() {
      if (!this.story.articleType || !this.story.articleType.trim()) {
          this.$message.error(this.$t('select_story_type'));
          return false;
      }

      if (!this.story.writingPerspective || !this.story.writingPerspective.trim()) {
          this.$message.error(this.$t('select_perspective'));
          return false;
      }
      // return false;
      ArticleApi.create(this.story).then(res => {
          if(res.data.code == 0){
            let data = res.data.data
            this.setStory(data)
            console.log('story', this.story);
            this.$router.push('/workspace/genbyoutline');
          }else{
            this.$message.error(res.data.msg);
          }
      })
    },
    handleRemove(item) {
      this.$confirm(this.$t('delete_confirm'),this.$t('confirm'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        customClass: 'custom-confirm',
        center: false
      }).then(() => {
        ArticleApi.remove(item.id).then(res => {

        });
      }).catch((e) => {console.log('error', e)});
    },
    itemClick(item){
      this.setStory(item)
      setTimeout(()=>{
        if(!item.stepNumber || item.stepNumber == 0 || item.stepNumber == 1){
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
              this.$router.push('/workspace/gen')
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea')
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline')
          }
        }else {
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
            this.$router.push('/workspace/gen' + (item.stepNumber-1))
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea' + item.stepNumber)
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline' + item.stepNumber)
          }
        }
      }, 300)
    },
    handleEnum() {
      EnumApi.map().then(res => {
        let result = res.data.data;
        console.log('result', result);
        let tree = this.$buildTree(result, 0, 0)
        console.log('tree', tree);
        this.setStoryTiaojian(tree)
      })
      let that = this;
      EnumApi.list().then(res => {
        let result = res.data.data;
        result.ArticleStateEnum.unshift({name: '-1', desc: this.$t('all')})
        result.ArticleStateEnum.push({name: 'SIGN_OK', desc: this.$t('signed')})
        result.ArticleGenTypeEnum.shift()
        result.ArticleGenTypeEnum.unshift({name: '-1', desc: this.$t('all')})
        that.setEnums(result)
      })
    },
    sortByCode(array, order = 'asc') {
      return [...array].sort((a, b) => {
        if (typeof a.code === 'number' && typeof b.code === 'number') {
          return order === 'asc' ? a.code - b.code : b.code - a.code;
        } else {
          return order === 'asc'
            ? a.code.toString().localeCompare(b.code.toString())
            : b.code.toString().localeCompare(a.code.toString());
        }
      });
    },
    handlePage(item) {
      if(item && item.name != 'ALL'){
        this.genTypeActive = item.name
        this.data = this.data1.filter(i => item.name==i.type)
      }else{
        this.genTypeActive = 'ALL'
        this.data = this.data1
      }
    },
    handleMessage() {
      CultureApi.page({size: 100}).then(res => {
        let result = res.data.data;
        this.dongtai = result.records
      })
      EvaluationApi.page({size: 100}).then(res => {
        let result = res.data.data;
        this.tougao = result.records
      })
    }
  }
}
</script>

<style scoped lang="scss">
.layout {
  height: 100%;
}
.main {
  min-height: 1px;
  flex: 1;
}
.el-aside {
  padding: 0px;
  margin-bottom: 0 !important;
  height: 100%;
  width: 17rem !important;
}
.el-scrollbar {
  height: 100%;
  background-color: #ffffff;
}
.el-header {
  padding: 0px !important;
  background-color: #001A40;
}
.el-main {
  height: 100%;
  overflow: hidden; /* 禁止父容器滚动 */
}
.dialog-container {
  background: #F4F5F9;
  border-radius: 20px;
  height: calc( 100% - 1rem );
  margin: 0 1rem 1rem;
  margin-bottom: 1rem;
  padding:1rem;
  overflow: auto;
}
.el-drawer.rtl {
    right: 0;
    overflow-y: auto !important;
}
/deep/ .el-card {
    // border: 0;
    overflow-y: hidden !important;
}
/deep/ .el-empty__image img {
  margin-top: 20px;
}
.custom-select {
    /deep/ .el-input__inner {
      border-radius: 20px;
      height: 1.5rem;
      line-height: 1.5rem;
    }
    /deep/ .el-input__suffix {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
}

/deep/ .el-carousel__item {
  white-space: nowrap;
  overflow: hidden;        /* 隐藏超出元素盒子的内容 */
  text-overflow: ellipsis; /* 显示省略号(...) */
}
.search-title {
  /deep/ .el-input__inner {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
  }
  /deep/ .el-input__suffix {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
.el-input__inner .el-input__inner:hover {
    /deep/ {
      // border-color: transparent; /* 边框颜色设置为透明 */
      // border: none;
      // outline: none;
    }
}

.writer-home-card-box{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}
.writer-home-card {
  flex: 1;
  cursor: pointer;
  // border: 1px solid red;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 14px;
  box-sizing: border-box; /* 边框计算在宽度内 */
  &-title-en {
    font-weight: 400;
    font-size: 14px;
    color: rgba(255,255,255,.8);
    line-height: 22px;
    border-radius: 20px;
    display: inline-block;
    padding: .1rem 1rem;
  }
  &-title {
    font-weight: 600;
    font-size: 28px;
    color: rgba(0,0,0,0.9);
    margin: 1rem 0;
  }
  &-top {
    display: flex;
    justify-content: space-between;
    &-img {
      width: 7rem;
      margin-top:  -.7rem;
    }
  }
  &-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    &-img {
      width: 1rem;
    }
  }
  &-up {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.4);
    line-height: 22px;
    display: flex;
    align-items: flex-start; /* 顶部对齐 */
    &-icon {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #2BA471;
      line-height: 1rem;
      margin-right: .5rem;
      border-radius: 3px;
      padding: .25rem .5rem;
      &-img {
        width: 1rem;
      }
    }
  }
}

.word-count-tail {
  border-radius: 6px 0px 20px 0px;
  width: auto; /* 默认值，但明确设置有助于理解 */
  white-space: nowrap; /* 防止文本换行 */
  display: inline-block;
  padding: .25rem 1.5rem .25rem 1rem;
  // font-weight: 600;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  &-cdp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F2F3FE 100%);
    color: #0052D9;
  }
  &-dp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F6F2FE 100%);
    color: #4043FF;
  }
  &-cp{
    background: linear-gradient( 90deg, #FFE9BC 0%, #FFF7DC 100%);
    color: #FD733B;
  }
}
.data-empty {
  background: #FFFFFF;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.1);
  border-radius: 0px 20px 20px 20px;
  padding: 1rem;
}
/deep/ .el-empty {
  min-height: 30vh !important;
}
/deep/ .el-empty__bottom {
  margin-top: 10px;
}
.authoring-tool {
  background: #FFFFFF;
  border-radius: 30px 30px 30px 30px;
  padding: 20px;
}

.authoring-tool-box {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  &-item {
    background: #F6F7FF;
    box-shadow: none;
    border-radius: 20px 20px 20px 20px;
    padding: 1rem;
    min-width: 200px;
    cursor: pointer;
    &-title {
      font-weight: 600;
      font-size: 16px;
      color: #242424;
      padding: 1rem 0;
    }
    &-subtitle {
      font-weight: 400;
      font-size: 12px;
      color: rgba(36,36,36,0.5);
    }
  }
  &-item:hover {
    box-shadow: 4px 4px 15px 0 rgba(54, 110, 244, .2) !important;
  }
}

/* 假设你的菜单类名为 .my-menu */
/deep/ .el-menu-agent .el-menu-item {
  border-radius: 6px !important;
  margin: 0 1rem 6px;
  height: 2.5rem;
  line-height: 2.5rem;
}
/deep/ .el-menu-agent .el-menu-item:hover {
  background-color: #4B4B4B !important;
}
.el-menu-agent .el-menu-item.is-active {
  background-color: #0252D9 !important; /* 激活状态下的背景颜色 */
}

.news-box {
  display: flex;
  margin-bottom: 1rem;
  &-pc{
    justify-content: space-between;
  }
  &-mobile{
    flex-direction: column;
  }
  &-last {
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
    display: flex;
    align-items: center;
    padding: 0 1rem 0 .25rem;
    &-pc{
      flex: 1;
      margin-right: 1rem;
    }
    &-mobile{
      margin-bottom: 1rem;
    }
    &-title {
      color: #366EF4;
      font-weight: 600;
      line-height: 24px;
      font-size: 16px;
      margin-left: 10px;
    }
    &-content {
      margin-left: 1rem;
      color: #242424;
      flex: 1;
      font-size: 14px;
    }
  }
  &-contribute {
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
    display: flex;
    align-items: center;
    padding: 0 1rem 0 .25rem;
    width: 380px;
    &-title {
      color: #366EF4;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      text-wrap: nowrap;
      margin-left: 10px;
    }
    &-content {
      margin-left: 1rem;
      color: #366EF4;
      font-size: 14px;
    }
  }
}
/* 小屏下的样式 */
@media (max-width: 767px) {
  .authoring-tool-box-item {
    width: 100%;
  }
}
// mly end
</style>
